import moment from 'moment';

import { useSelector } from 'react-redux';
import { hasSessionAvailabilityError } from 'redux/selectors/mentorship-program-sessions';

import {
  AvailabilityCalendarContextProvider,
  AvailabilityCalendarContextType,
} from './availability-calendar-context';

import AvailabilityCalendarGrid from './availability-calendar-grid';
import AvailabilityCalendarHeader from './availability-calendar-header';
import AvailabilityCalendarWeekdays from './availability-calendar-weekdays';
import AvailabilityCalendarError from './availability-calendar-error';
import AvailabilityCalendarNote from './availability-calendar-note';

type AvailabilityCalendarProps = {
  selectedDate: string;
  endDate?: string;
  setSelectedDate: (date: string) => void;
};

const AvailabilityCalendar = (props: AvailabilityCalendarProps) => {
  const {
    selectedDate,
    endDate = '',
    setSelectedDate,
  } = props;

  const startDateForCurrentWeek = selectedDate
    ? moment(selectedDate).locale('en').format('YYYY-MM-DD')
    : moment().locale('en').format('YYYY-MM-DD');

  const availabilityCalendarValue: AvailabilityCalendarContextType = {
    selectedDate,
    endDate,
    setSelectedDate,
    startDateForCurrentWeek,
  };

  const hasError = useSelector(hasSessionAvailabilityError);

  return (
    <AvailabilityCalendarContextProvider value={availabilityCalendarValue}>
      <div className='w-100 availability-calendar-container'>
        {hasError ? (
          <AvailabilityCalendarError />
        ) : (
          <>
            <AvailabilityCalendarHeader />
            <AvailabilityCalendarNote />
            <AvailabilityCalendarWeekdays />
            <AvailabilityCalendarGrid />
          </>
        )}
      </div>
    </AvailabilityCalendarContextProvider>
  );
};

export default AvailabilityCalendar;
